"use client";

import React, { useState } from "react";
import { ShieldCheck, Server, Network, Search, FileSearch, Cpu, Lock, Zap, CircleCheck, ArrowRight, ArrowUp, Layers, Database, Globe, Wifi } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ArchitettureESicurezza() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const BlueprintGrid = () => <div className="absolute inset-0 pointer-events-none opacity-[0.03]" style={{
    backgroundImage: 'linear-gradient(var(--primary) 1px, transparent 1px), linear-gradient(90deg, var(--primary) 1px, transparent 1px)',
    backgroundSize: '40px 40px'
  }} />;
  return <section id="architetture-e-sicurezza" className="dark bg-background text-foreground py-24 relative overflow-hidden">
      <BlueprintGrid />
      
      <div className="hidden md:block absolute top-0 left-1/4 w-96 h-96 bg-primary/5 rounded-full blur-3xl -translate-y-1/2 pointer-events-none" />
      <div className="hidden md:block absolute bottom-0 right-1/4 w-96 h-96 bg-primary/5 rounded-full blur-3xl translate-y-1/2 pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        
        <div className="max-w-6xl mx-auto">
          <Tabs defaultValue="discovery" className="w-full flex flex-col gap-12">
            
            <div ref={ref} className={`max-w-3xl mx-auto text-center transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 text-primary text-xs font-mono tracking-wider mb-6">
                <ShieldCheck className="w-3 h-3" />
                SECURE INFRASTRUCTURE
              </div>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 tracking-tight text-white">
                Architetture <span className="text-primary">Resilienti</span> e Sicure
              </h2>
              <p className="text-lg text-muted-foreground leading-relaxed">Un approccio strutturato alla progettazione IT, basato sull’analisi dell’infrastruttura esistente. L’obiettivo è creare sistemi affidabili e scalabili, capaci di supportare la crescita e la continuità operativa delle aziende.</p>
            </div>

            <div className="flex justify-center mb-6 md:mb-10">
              <TabsList className="bg-secondary/50 border border-border p-1 h-auto flex flex-col sm:flex-row w-full sm:w-auto justify-center gap-2 backdrop-blur-sm">
                <TabsTrigger value="discovery" className="w-full sm:w-auto px-6 py-3 text-sm md:text-base data-[state=active]:bg-primary data-[state=active]:text-primary-foreground transition-all duration-300">
                  <Search className="w-4 h-4 mr-2" />
                  1. Analisi & Discovery
                </TabsTrigger>
                <TabsTrigger value="design" className="w-full sm:w-auto px-6 py-3 text-sm md:text-base data-[state=active]:bg-primary data-[state=active]:text-primary-foreground transition-all duration-300">
                  <Layers className="w-4 h-4 mr-2" />
                  2. Architettura & Design
                </TabsTrigger>
                <TabsTrigger value="deployment" className="w-full sm:w-auto px-6 py-3 text-sm md:text-base data-[state=active]:bg-primary data-[state=active]:text-primary-foreground transition-all duration-300">
                  <Zap className="w-4 h-4 mr-2" />
                  3. Implementazione
                </TabsTrigger>
              </TabsList>
            </div>

            <TabsContent value="discovery" className="animate-in fade-in slide-in-from-bottom-4 duration-500 mt-6 md:mt-10">
              <div className="grid lg:grid-cols-2 gap-6 md:gap-12 items-start">
                <div className="space-y-8">
                  <div className="space-y-4">
                    <h3 className="text-2xl font-bold text-white flex items-center gap-3">
                      <FileSearch className="text-primary w-6 h-6" />
                      Audit e Mappatura
                    </h3>
                    <p className="text-muted-foreground">Prima di ogni intervento analizziamo l’infrastruttura esistente per comprenderne struttura, configurazioni e punti critici. Questo ci permette di individuare colli di bottiglia, configurazioni non ottimali e possibili miglioramenti.</p>
                  </div>
                  
                  <ul className="space-y-4">
                    {["Analisi del traffico di rete e latenze", "Inventario asset hardware e software", "Verifica configurazioni e stato dei sistemi", "Analisi architettura e dipendenze infrastrutturali"].map((item, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                        <div className="mt-1 w-5 h-5 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
                          <div className="w-1.5 h-1.5 rounded-full bg-primary" />
                        </div>
                        <span className="text-sm md:text-base text-gray-300">{item}</span>
                      </li>)}
                  </ul>

                  <div className="pt-4">
                    <Button asChild variant="outline" className="border-primary/30 hover:bg-primary/10 hover:text-primary">
                      <Link to="/ContactsPage">Richiedi un Audit Preliminare</Link>
                    </Button>
                  </div>
                </div>

                <div className="mt-8 relative h-[300px] md:h-[400px] bg-card/30 border border-border rounded-xl overflow-hidden backdrop-blur-sm p-8 group">
                  <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:20px_20px]" />
                  
                  <div className="relative h-full w-full flex items-center justify-center">
                    <div className="relative z-10 flex flex-col items-center gap-2 animate-pulse">
                      <div className="w-16 h-16 rounded-full bg-primary/20 border-2 border-primary flex items-center justify-center shadow-[0_0_30px_rgba(6,182,212,0.3)]">
                        <Search className="w-8 h-8 text-primary" />
                      </div>
                      <span className="text-xs font-mono text-primary bg-background/80 px-2 py-1 rounded border border-primary/30">SCANNING...</span>
                    </div>

                    {[{
                    icon: Server,
                    label: "SRV-01",
                    pos: "top-5 left-5 md:top-10 md:left-10"
                  }, {
                    icon: Database,
                    label: "DB-MAIN",
                    pos: "bottom-10 left-10 md:bottom-20 md:left-20"
                  }, {
                    icon: Wifi,
                    label: "WLAN-AP",
                    pos: "top-10 right-5 md:top-20 md:right-10"
                  }, {
                    icon: Lock,
                    label: "FW-EDGE",
                    pos: "bottom-5 right-10 md:bottom-10 md:right-20"
                  }].map((node, i) => <div key={i} data-index={i} className={`absolute ${node.pos} flex flex-col items-center gap-1 transition-all duration-1000 group-hover:scale-110`}>
                        <div className="w-10 h-10 rounded bg-secondary border border-border flex items-center justify-center text-muted-foreground">
                          <node.icon className="w-5 h-5" />
                        </div>
                        <span className="text-[10px] font-mono text-muted-foreground">{node.label}</span>
                        <div className="absolute inset-0 flex items-center justify-center pointer-events-none -z-10">
                           <div className={`absolute w-[100px] h-[1px] bg-gradient-to-r from-primary/50 to-transparent 
                             ${i === 0 ? 'rotate-45 translate-x-10 translate-y-10' : ''}
                             ${i === 1 ? '-rotate-45 translate-x-10 -translate-y-10' : ''}
                             ${i === 2 ? '-rotate-135 -translate-x-10 translate-y-10' : ''}
                             ${i === 3 ? 'rotate-135 -translate-x-10 -translate-y-10' : ''}
                           `} />
                        </div>
                      </div>)}
                  </div>
                  
                  <div className="absolute bottom-4 left-4 text-[10px] font-mono text-muted-foreground/50">
                    SYS.DIAG.MODE: ACTIVE
                  </div>
                </div>
              </div>
            </TabsContent>

            <TabsContent value="design" className="animate-in fade-in slide-in-from-bottom-4 duration-500 mt-6 md:mt-10">
              <div className="grid lg:grid-cols-2 gap-6 md:gap-12 items-start">
                <div className="space-y-8 lg:order-2">
                  <div className="space-y-4">
                    <h3 className="text-2xl font-bold text-white flex items-center gap-3">
                      <Network className="text-primary w-6 h-6" />
                      Progettazione dell'Architettura
                    </h3>
                    <p className="text-muted-foreground">Progettiamo architetture IT affidabili e scalabili, basate su principi di ridondanza, segmentazione della rete e protezione dei sistemi. L’obiettivo è garantire stabilità dell’infrastruttura e continuità operativa.</p>
                  </div>
                  
                  <ul className="space-y-4">
                    {["Segmentazione di rete (VLAN) per sicurezza e performance", "Architetture High Availability (HA) e Failover", "Integrazione cloud e infrastrutture on‑premise", "Progettazione accessi sicuri e gestione delle identità"].map((item, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                        <div className="mt-1 w-5 h-5 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
                          <div className="w-1.5 h-1.5 rounded-full bg-primary" />
                        </div>
                        <span className="text-sm md:text-base text-gray-300">{item}</span>
                      </li>)}
                  </ul>

                  <div className="pt-4">
                    <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90">
                      <Link to="/SolutionsPage">Esplora le Soluzioni</Link>
                    </Button>
                  </div>
                </div>

                <div className="mt-8 relative h-[300px] md:h-[400px] bg-card/30 border border-border rounded-xl overflow-hidden backdrop-blur-sm p-8 lg:order-1">
                  <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:20px_20px]" />
                  
                  <div className="relative h-full w-full flex flex-col justify-center gap-6 px-8">
                    
                    <div className="border border-dashed border-primary/40 rounded-lg p-3 bg-primary/5 relative">
                      <div className="absolute -top-3 left-4 bg-background px-2 text-[10px] font-mono text-primary">CLOUD Services</div>
                      <div className="flex justify-around">
                        <Globe className="w-6 h-6 text-primary/70" />
                        <Database className="w-6 h-6 text-primary/70" />
                      </div>
                    </div>

                    <div className="h-8 w-full flex justify-center relative">
                      <div className="h-full w-[1px] bg-primary/30"></div>
                      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-background border border-primary/50 rounded px-2 py-0.5 text-[8px] font-mono text-primary">VPN / SD-WAN</div>
                    </div>

                    <div className="border border-primary/60 rounded-lg p-4 bg-card/50 relative shadow-lg">
                      <div className="absolute -top-3 left-4 bg-background px-2 text-[10px] font-mono text-primary font-bold">CORE INFRASTRUCTURE</div>
                      <div className="grid grid-cols-3 gap-4 text-center">
                        <div className="flex flex-col items-center gap-1">
                          <div className="w-8 h-8 rounded bg-secondary flex items-center justify-center"><Lock className="w-4 h-4" /></div>
                          <span className="text-[8px] font-mono">FW-HA</span>
                        </div>
                        <div className="flex flex-col items-center gap-1">
                          <div className="w-8 h-8 rounded bg-secondary flex items-center justify-center"><Cpu className="w-4 h-4" /></div>
                          <span className="text-[8px] font-mono">CORE-SW</span>
                        </div>
                        <div className="flex flex-col items-center gap-1">
                          <div className="w-8 h-8 rounded bg-secondary flex items-center justify-center"><Server className="w-4 h-4" /></div>
                          <span className="text-[8px] font-mono">VIRT-HOST</span>
                        </div>
                      </div>
                    </div>

                    <div className="flex justify-between px-4 pt-2">
                      <div className="h-4 w-[1px] bg-border mx-auto"></div>
                      <div className="h-4 w-[1px] bg-border mx-auto"></div>
                      <div className="h-4 w-[1px] bg-border mx-auto"></div>
                    </div>
                    <div className="flex justify-between text-[10px] font-mono text-muted-foreground px-2">
                      <span>OFFICE</span>
                      <span>WAREHOUSE</span>
                      <span>REMOTE</span>
                    </div>

                  </div>
                </div>
              </div>
            </TabsContent>

            <TabsContent value="deployment" className="animate-in fade-in slide-in-from-bottom-4 duration-500 mt-6 md:mt-10">
              <div className="grid lg:grid-cols-2 gap-6 md:gap-12 items-start">
                <div className="space-y-8">
                  <div className="space-y-4">
                    <h3 className="text-2xl font-bold text-white flex items-center gap-3">
                      <Zap className="text-primary w-6 h-6" />
                      Implementazione e Deployment
                    </h3>
                    <p className="text-muted-foreground">Dalla configurazione hardware al rollout dei sistemi, gestiamo l’intero ciclo di deployment. Riduciamo al minimo i tempi di fermo e garantiamo che ogni dispositivo sia operativo fin dal primo avvio.</p>
                  </div>
                  
                  <ul className="space-y-4">
                    {["Staging e pre-configurazione in laboratorio", "Deployment massivo tramite MDM e strumenti di automazione", "Test di accettazione (UAT) e validazione funzionale", "Formazione tecnica e documentazione operativa"].map((item, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                        <div className="mt-1 w-5 h-5 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
                          <div className="w-1.5 h-1.5 rounded-full bg-primary" />
                        </div>
                        <span className="text-sm md:text-base text-gray-300">{item}</span>
                      </li>)}
                  </ul>

                  <div className="pt-4">
                    <Button asChild variant="secondary" className="hover:bg-secondary/80">
                      <Link to="/ServicesPage">Vedi i Servizi di Deployment</Link>
                    </Button>
                  </div>
                </div>

                <div className="mt-8 relative h-[300px] md:h-[400px] bg-card/30 border border-border rounded-xl overflow-hidden backdrop-blur-sm p-8">
                  <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:20px_20px]" />
                  
                  <div className="relative h-full w-full flex flex-col justify-center items-center gap-4">
                    
                    {[{
                    step: "01",
                    label: "STAGING",
                    status: "complete"
                  }, {
                    step: "02",
                    label: "CONFIG",
                    status: "complete"
                  }, {
                    step: "03",
                    label: "DEPLOY",
                    status: "active"
                  }, {
                    step: "04",
                    label: "VERIFY",
                    status: "pending"
                  }].map((item, i) => <div key={i} data-index={i} className="flex items-center w-full max-w-xs gap-4 group">
                        <div className={`w-8 h-8 rounded-full flex items-center justify-center border-2 shrink-0 transition-colors duration-500
                          ${item.status === 'complete' ? 'bg-primary border-primary text-primary-foreground' : ''}
                          ${item.status === 'active' ? 'bg-primary/20 border-primary text-primary animate-pulse' : ''}
                          ${item.status === 'pending' ? 'bg-transparent border-muted text-muted-foreground' : ''}
                        `}>
                          {item.status === 'complete' ? <CircleCheck className="w-4 h-4" /> : <span className="text-xs font-bold">{item.step}</span>}
                        </div>

                        <div className={`flex-1 p-3 rounded border transition-all duration-300
                          ${item.status === 'active' ? 'bg-primary/10 border-primary/50 translate-x-2' : 'bg-secondary/30 border-border'}
                        `}>
                          <div className="flex justify-between items-center">
                            <span className={`text-xs font-mono font-bold ${item.status === 'active' ? 'text-primary' : 'text-muted-foreground'}`}>
                              {item.label}
                            </span>
                            {item.status === 'active' && <div className="w-2 h-2 rounded-full bg-primary animate-ping" />}
                          </div>
                          
                          {item.status === 'active' && <div className="w-full h-1 bg-primary/20 rounded-full mt-2 overflow-hidden">
                              <div className="h-full bg-primary w-2/3 animate-[shimmer_2s_infinite]" />
                            </div>}
                        </div>
                      </div>)}

                    <div className="absolute left-[calc(50%-10rem+1rem)] top-10 bottom-10 w-0.5 bg-border -z-10 ml-[1px]" />

                  </div>
                </div>
              </div>
            </TabsContent>

          </Tabs>
        </div>

        <div className="mt-20 text-center">
          <p className="text-muted-foreground mb-6 max-w-2xl mx-auto">Ogni infrastruttura ha esigenze diverse. Contattaci per analizzare il tuo ambiente IT e valutare insieme la soluzione più adatta.</p>
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 shadow-[0_0_20px_rgba(6,182,212,0.3)]">
            <Link to="/ContactsPage">
              Parla con un Consulente <ArrowRight className="ml-2 w-4 h-4" />
            </Link>
          </Button>
        </div>

      </div>

      <Button variant="outline" size="icon" onClick={() => window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })} className="fixed left-4 bottom-4 z-50 rounded-full border-primary/20 bg-background/80 backdrop-blur-sm hover:bg-primary hover:text-primary-foreground transition-all duration-300 shadow-[0_0_15px_rgba(6,182,212,0.2)]" aria-label="Torna su">
        <ArrowUp className="w-5 h-5" />
      </Button>
    </section>;
}